import { jsx as _jsx } from "react/jsx-runtime";
import { CELL_TYPE, MARK_INVALID } from '../defaults';
const Board = (props) => {
    const cellClick = (cell, rowIdx, cellIdx) => {
        props.onCellClick(cell, rowIdx, cellIdx);
    };
    const getCellClasses = (cell) => {
        let classes = '';
        classes = `${cell.type === CELL_TYPE.SET ? 'sudoku-puzzle__cell--set' : ''} ${cell.type === CELL_TYPE.HINT ? 'sudoku-puzzle__cell--hint' : ''}`;
        if (MARK_INVALID || cell.showState) {
            classes += ` ${cell.valid ? 'sudoku-puzzle__cell--valid' : 'sudoku-puzzle__cell--invalid'}`;
        }
        return classes;
    };
    const renderCell = (cell, rowIdx, cellIdx) => {
        return (_jsx("td", { onClick: e => { e.preventDefault(); cellClick(cell, rowIdx, cellIdx); }, className: `sudoku-puzzle__cell ${cellIdx % 3 === 0 ? 'sudoku-puzzle__cell--edge' : ''} ${getCellClasses(cell)}`, children: cell.value > 0 ?
                _jsx("img", { className: "sudoku-puzzle__image", src: props.images[cell.value - 1] || '' }) :
                _jsx("div", { className: "sudoku-puzzle__empty" }) }, `${rowIdx}-${cellIdx}`));
    };
    return (_jsx("table", { className: "sudoku-puzzle sudoku-puzzle--playable", children: _jsx("tbody", { children: props.puzzle.map((row, rowIdx) => {
                return (_jsx("tr", { className: `sudoku-puzzle__row ${rowIdx % 3 === 0 ? 'sudoku-puzzle__row--edge' : ''}`, children: row.map((cell, cellIdx) => {
                        return renderCell(cell, rowIdx, cellIdx);
                    }) }, rowIdx));
            }) }) }));
};
export default Board;
